import countriesData from './countries-data';
import statesData from './states-data';

export default {
  countriesData,
  statesData,
  sessionTypesData: ['Family Portrait ', 'Wedding', 'Senior', 'Newborn', 'Maternity', 'Boudoir', 'Event'],
  supportEmail: 'support@heyned.com',
  sentry: {
    dsn: 'https://c12837c716de40ff9c59cf6ce9e62b22@sentry.io/273461',
  },
  currencyCodes: ['AUD', 'USD', 'CAD', 'EUR', 'GBP', 'NZD'],
};



// WEBPACK FOOTER //
// ./src/lib/constants/index.js